import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

//  http://wiki.xunlei.cn/pages/viewpage.action?pageId=127574982
export const benefit_homepage = createAsyncThunk(
  'live/vip/gift_packs',
  async (arg, store: any) => {
    const resp = await http.post('/live/vip/gift_packs', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export enum StatusEnum {
  未领取 = 1,
  已领取 = 2,
  还未到时间 = 3,
}
export interface InitialStateType {
  birth_day_gift_packs_info: {
    days?: number
    birthday_times?: number
  }
  festival_gift_packs_info: {
    gifts?: Array<{
      name: string
      icon: string
      status: StatusEnum
      level: number
    }>
  }
}

const initialState: InitialStateType = {
  birth_day_gift_packs_info: {},
  festival_gift_packs_info: {
    gifts: [],
  },
}

export const VipBenefitSlice = createSlice({
  name: 'Animal_Dolphin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(benefit_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default VipBenefitSlice.reducer
export const VipBenefitActions = VipBenefitSlice.actions

export const useVipBenefitState = () => {
  const data = useSelector((state) => {
    return state.Animal_Dolphin
  })
  return data
}
